import { AaasAppSelectors } from '@va/aaas/shared/selectors';
import { DashboardType } from '@va/aaas/shared/types';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export const useIsWebsiteSelectorEnabled = () => {
  const dashboardType = useSelector(AaasAppSelectors.dashboardType);
  const theme = useSelector(AaasAppSelectors.theme);

  const enabled = useMemo(() => {
    if (dashboardType === DashboardType.website) return false;
    return theme?.websiteSelectorEnabled;
  }, [dashboardType, theme?.websiteSelectorEnabled]);

  return enabled;
};
